import { useEffect, useRef, useCallback } from 'react';
export const useWebSocket = (onMessage) => {
  const wsRef = useRef(null);
  const onMessageRef = useRef(onMessage);
  
  // Update the ref when onMessage changes
  useEffect(() => {
    onMessageRef.current = onMessage;
  }, [onMessage]);
  
  useEffect(() => {
    const wsUrl = process.env.REACT_APP_BACKEND_URL?.replace('http', 'ws') || 'ws://localhost:8000';
    const ws = new WebSocket(`${wsUrl}/api/ws`);
    
    ws.onopen = () => {
      // WebSocket connected
    };
    
    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        onMessageRef.current(data);
      } catch (error) {
        // Error parsing WebSocket message
      }
    };
    
    ws.onerror = (error) => {
      // WebSocket error occurred
    };
    
    ws.onclose = (event) => {
      // WebSocket disconnected
    };
    
    wsRef.current = ws;
    
    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, []); // Remove onMessage from dependencies to prevent reconnection
  
  return wsRef.current;
}; 